import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["buttonCategory", "title", "className", "children", "ariaLabel", "isNav", "flip"];
var _this = this;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.map.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/* eslint-disable jsx-a11y/no-redundant-roles */
// jsx-a11y/no-redundant-roles is triggered for the button element
// but without explicitly setting the role for the button, an accessibility
// violation is raised by @ibma
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { usePopper } from 'react-popper';
import { IconSet, OverflowMenuOptionList } from '..';
import { uniqueIdForComponent } from '../util';
import useClickOutsideToggle from '../hooks/useClickOutsideToggle';
var OverflowMenu = function OverflowMenu(_ref) {
  var buttonCategory = _ref.buttonCategory,
    title = _ref.title,
    className = _ref.className,
    children = _ref.children,
    ariaLabel = _ref.ariaLabel,
    isNav = _ref.isNav,
    flip = _ref.flip,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var uuid = "overflowMenu-".concat(uniqueIdForComponent(_this));
  var _useClickOutsideToggl = useClickOutsideToggle(false),
    clickContainerRef = _useClickOutsideToggl.clickContainerRef,
    isComponentVisible = _useClickOutsideToggl.value,
    setIsComponentVisible = _useClickOutsideToggl.setIsComponentVisible;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    referenceElement = _useState2[0],
    setReferenceElement = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    popperElement = _useState4[0],
    setPopperElement = _useState4[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: "bottom-".concat(flip ? 'start' : 'end'),
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 6]
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  function isButtonStyle(category) {
    if (category && (category !== 'icon' || category !== 'link-default' || category !== 'link-default-inverse')) {
      return true;
    }
    return false;
  }
  var titleId = title && uniqueIdForComponent();
  if (!ariaLabel && !title) {
    console.error('Expected `title` or `ariaLabel` to be supplied to the Overflow component');
  }
  if (isNav && !isNav.currentItemLabel) {
    console.warn("Navigation menu should provide a label for current menu items. `isNav={{ currentItemLabel : 'Current link' }}`");
  }
  var Tag = isNav ? 'nav' : 'div';
  var labelId = "".concat(uuid, "-current-page-aural-indicator-label");
  var styleClass = classnames('wds-c-overflow-menu', {
    'wds-c-overflow-menu--flip': flip,
    'wds-c-overflow-menu--button-style-trigger': isButtonStyle(buttonCategory),
    'wds-c-overflow-menu--default-link-style-trigger': buttonCategory && (buttonCategory === 'link-default' || buttonCategory === 'link-default-inverse'),
    'wds-c-overflow-menu--with-title': title && !buttonCategory
  }, className);
  var buttonStyleClass = classnames('wds-c-overflow-menu__trigger', _defineProperty({}, "wds-c-button wds-c-button--".concat(buttonCategory), buttonCategory && title), {
    'wds-c-overflow-menu__button': !(title && buttonCategory)
  });
  var menuItems = React.Children.map(children, function (child) {
    var settings = {
      'aria-describedby': child.props.current && isNav ? labelId : undefined,
      isNavItem: !!(isNav || _typeof(isNav) === 'object')
    };
    if (child && (child.props.current || isNav)) {
      return /*#__PURE__*/React.cloneElement(child, settings);
    }
    return child;
  });
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: styleClass
  }, isNav ? {
    'aria-label': ariaLabel || title
  } : '', {
    ref: clickContainerRef
  }), /*#__PURE__*/React.createElement("button", _extends({
    ref: setReferenceElement,
    type: "button",
    className: buttonStyleClass
  }, isComponentVisible ? {
    'aria-controls': uuid
  } : {}, ariaLabel ? {
    'aria-label': ariaLabel
  } : {
    'aria-labelledby': titleId
  }, {
    "aria-expanded": isComponentVisible,
    "aria-haspopup": "true",
    onClick: function onClick(event) {
      event.preventDefault();
      event.target.focus();
      setIsComponentVisible(!isComponentVisible);
    }
  }, otherProps), title ? /*#__PURE__*/React.createElement("span", {
    id: titleId
  }, /*#__PURE__*/React.createElement("span", {
    className: "wds-c-overflow-menu__trigger-label"
  }, title, " "), /*#__PURE__*/React.createElement(IconSet, {
    className: "wds-c-overflow-menu__trigger-label-icon",
    decorative: true,
    name: "caret-up",
    size: "xsmall"
  })) : /*#__PURE__*/React.createElement(IconSet, {
    decorative: true,
    name: "ellipsis",
    size: "medium"
  })), isComponentVisible && /*#__PURE__*/React.createElement("div", _extends({
    id: uuid,
    ref: setPopperElement,
    style: styles.popper,
    className: "wds-c-overflow-menu__options-container"
  }, attributes.popper), /*#__PURE__*/React.createElement(OverflowMenuOptionList, {
    labelledBy: titleId,
    isNav: !!(isNav || isNav && _typeof(isNav) === 'object' && isNav.constructor === Object),
    onClose: function onClose() {
      referenceElement.focus();
      setIsComponentVisible(false);
    }
  }, menuItems)), isComponentVisible && isNav && _typeof(isNav) === 'object' && isNav.currentItemLabel && /*#__PURE__*/React.createElement("div", {
    id: labelId,
    className: "wds-c-overflow-menu__current-label"
  }, isNav.currentItemLabel));
};
OverflowMenu.propTypes = {
  /** Applied to the overflow menu's root element. */
  className: PropTypes.string,
  /**
   Label describing the purpose of the menu.
   When omitted, the ariaLabel must be used to describe the purpose of the menu.
  */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Used by screen readers. This property can be omitted when the title is supplied. */
  ariaLabel: PropTypes.string,
  /** OverflowMenuOption components  */
  children: PropTypes.node.isRequired,
  /**
   Category for the Button that shows the overflow menu.
   One of ['primary', 'secondary', 'danger', 'outline', 'success', 'link', 'icon'].
   When you specify the `buttonCategory`, you also need to set the
   `title`. Omitting this property will display the default icon.
  */
  buttonCategory: PropTypes.oneOf(['primary', 'secondary', 'danger', 'outline', 'success', 'link', 'icon', 'link-default', 'link-default-inverse']),
  /** Overflow is a navigation, expects `object` with a label for currently active links to be supplied ie. `isNav={{ currentItemLabel : 'Current link' }}`' */
  isNav: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  /** Indicates that the menu opens in the opposite direction */
  flip: PropTypes.bool
};
OverflowMenu.defaultProps = {
  buttonCategory: undefined,
  className: undefined,
  title: undefined,
  ariaLabel: undefined,
  isNav: false,
  flip: false
};
OverflowMenu.displayName = 'OverflowMenu';
export default OverflowMenu;